// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { INVALID_DATE } from 'errors'

// ensures that dates like 2000/30/30 don't pass.
// v here is a momentjs object.
const validateDateIsValid = v => (
  isNaN(v._d.getDate()) && INVALID_DATE
)

export default validateDateIsValid
